import { RedemptionAsset, SetInterface, getNetworkInterface, sets } from 'abis/set/sets'
import { Address, zeroAddress } from 'viem'

export const transformAddress = (address: string, leading = 6, trailing = 4): string => {
  return `${address.substring(0, leading)}…${address.substring(address.length - trailing)}`
}

export const copyToClipboard = (content: string): void => {
  navigator.clipboard.writeText(content)
}

export const getBlockExplorerAddress = (address: string, network: number): string => {
  const explorer = getNetworkInterface(network).blockExplorer
  return `${explorer}/address/${address}`
}

export const getBlockExplorerToken = (address: string, network: number): string => {
  const explorer = getNetworkInterface(network).blockExplorer
  return `${explorer}/token/${address}`
}

export const transactionHashFormat = (address: string): string => {
  return `${address.substring(0, 15)}…${address.substring(address.length - 15)}`
}

/**
 * Grabs the network specific address from our sets
 * @param network the netwrok type
 * @param asset the asset we are after
 * @returns
 */
export const getNetworkSpecificAddress = (network: number, asset: RedemptionAsset): string => {
  const symbol = translateSymbolToWrapped(asset) as keyof SetInterface
  const address = sets[network][symbol] as string
  if (!address) {
    throw new Error(`No address found for ${symbol} on ${network}`)
  }

  return address
}

/**
 * if the symbol has an unwrapped equivalent, return it
 */

export const translateSymbolFromWrapped = (symbol: string): string => {
  switch (symbol) {
    case 'WETH':
      return 'ETH'
    case 'WAVAX':
      return 'AVAX'
    default:
      return symbol
  }
}

/**
 * If the symbol has a wrapped equivalant, return it
 * @param symbol
 * @returns
 */
export const translateSymbolToWrapped = (symbol: RedemptionAsset | string): string => {
  switch (symbol) {
    case 'ETH':
      return 'WETH'
    case 'AVAX':
      return 'WAVAX'
    default:
      return symbol
  }
}

export const isNativeToken = (address: Address) => address === zeroAddress
